import React from 'react';
import { AppBar, Button, Chip, Collapse, Tab, Tabs, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import HotelImagesRender from './HotelImagesRender';
import HotelCategoryRender from './HotelCategoryRender';
import KeyArrowDownIcon from 'material-ui-icons/KeyboardArrowDown';
import KeyArrowUpIcon from 'material-ui-icons/KeyboardArrowUp';
import ServiceIcon from 'material-ui-icons/RoomService';

import InfoIcon from 'material-ui-icons/Info';
import PhotoIcon from 'material-ui-icons/Photo';
import LocationIcon from 'material-ui-icons/LocationOn';
import ConditionsIcon from 'material-ui-icons/Copyright';
import ResultCardMap from '../Results/ResultCardMap';
import ResultCardPhotos from '../Results/ResultCardPhotos';
import { getUserInformation } from '../Login/loginService';
import HotelFacilitiesRender from './HotelFacilitiesRender';
import { translate } from 'react-i18next';
import { DoRender } from '../Utils/shared';

const styles = theme => ({
    hotelTitle: {
        color: 'var(--primary-color)'
    }
});

function TabContainer(props) {
    return (
        <div style={{
            display: 'table',
            margin: '0 auto',
            marginTop: '.8rem',
            padding: '1rem',
            backgroundColor: 'white'
        }}>
            {props.children}
        </div>
    );
}

function TabLabel(text, icon) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <div style={{ float: 'left' }}>{icon}</div>
            <div style={{ float: 'left', paddingLeft: '4px' }}>{text}</div>
        </div>
    );
}

class HotelHeaderRender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            reservation: null,
            tabSelected: 0
        };
        this.currentUser = getUserInformation();
    }

    componentDidMount() {
        if (this.props.expanded) {
            this.setState({ expanded: this.props.expanded });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.expanded) {
            this.setState({ expanded: nextProps.expanded });
        }
    }

    handleExpandClick = (event) => {
        this.setState({
            expanded: !this.state.expanded
        });
    };

    handleTabChange = (event, value) => {
        this.setState({
            tabSelected: value
        });
    };

    getHotelDescription = (hotel, lang) => {
        //@TODO: esto lo deberia resolver el back-end pero no se que paso en el medio
        let data = hotel ? (hotel['description_' + lang] || hotel.description) : '';
        data = data.split('\r\n').join('<br  1/>');
        return {
            __html: data,
        };
    }

    render() {
        const { classes, hotel, t, showImages = true } = this.props;
        const userlang = this.currentUser && this.currentUser.user_detail ?
            this.currentUser.user_detail.language.toLowerCase() : process.env.REACT_APP_DEFAULT_LANGUAGE;
        const { tabSelected } = this.state;
        return (
            <div>
                <table className={'HotelHeaderRender'}>
                    <tbody>
                        <tr>

                            <DoRender if={showImages}>
                                <td width="240px">
                                    <HotelImagesRender
                                        imageWidth={240}
                                        imageHeight={120}
                                        hotel={hotel} />
                                </td>
                            </DoRender>

                            <td>
                                <h3 className={classNames('ResultTitle ', classes.hotelTitle)}>{hotel ? hotel.name : t('COMMON.HOTEL') + '...'}
                                </h3>
                                <HotelCategoryRender category={hotel ? hotel.category : null} />
                                <Typography className={classes.hotelTitle}>
                                    {hotel && hotel.address ? hotel.address : ''}
                                </Typography>
                                <Typography className={classes.hotelTitle}>
                                    {hotel && hotel.telephone ? t('COMMON.PHONE') + ': ' + hotel.telephone : ''}
                                </Typography>
                            </td>
                            <td align="right" className="cmsArrowUpDown" >
                                <Chip label={t('CONFIRM_MODIFY_BOOKING.HOTEL_DETAIL_BUTTON')}
                                    deleteIcon={this.state.expanded ? <KeyArrowUpIcon /> : <KeyArrowDownIcon />}
                                    onDelete={this.handleExpandClick}
                                    onClick={this.handleExpandClick} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <Collapse in={this.state.expanded} timeout="0" unmountOnExit>
                    <AppBar position="static">
                        <Tabs value={tabSelected} onChange={this.handleTabChange}>
                            {hotel && hotel.description && hotel.description.length > 0 ?
                                <Tab label={TabLabel(t('CONFIRM_BOOKING.INFO'), <InfoIcon />)} /> : ''
                            }
                            {//hotel && hotel.images && hotel.images.length > 0 ?
                                //<Tab label={TabLabel(t('CONFIRM_BOOKING.PHOTOS'), <PhotoIcon />)} /> : ''
                            }
                            {hotel && hotel.location ?
                                <Tab label={TabLabel(t('CONFIRM_BOOKING.LOCATION'), <LocationIcon />)} /> : ''
                            }
                            {hotel && hotel.facilities ?
                                <Tab label={TabLabel(t('CONFIRM_BOOKING.SERVICES'), <ServiceIcon />)} /> : ''
                            }
                            {hotel && hotel.conditions ?
                                <Tab label={TabLabel(t('CONFIRM_BOOKING.CONDITIONS'), <ConditionsIcon />)} /> : ''
                            }
                        </Tabs>
                    </AppBar>
                    {
                        tabSelected === 0 && hotel &&
                        <TabContainer>
                            <article>
                                <Typography dangerouslySetInnerHTML={this.getHotelDescription(hotel, userlang)}>
                                </Typography>
                            </article>
                        </TabContainer>
                    }
                    {/*
                        tabSelected === 1 && hotel && hotel.images &&
                        <TabContainer>
                            <div style={{
                                margin: '0 auto', width: '100%',
                                maxWidth: '600px', paddingBottom: '10px'
                            }}>
                                <ResultCardPhotos images={hotel ? hotel.images : null} />
                            </div>
                        </TabContainer>
                        */}
                    {
                        tabSelected === 1 && hotel && hotel.location &&
                        <TabContainer>
                            <ResultCardMap
                                center={hotel.location}
                                zoom={11}
                            />
                        </TabContainer>
                    }
                    {
                        tabSelected === 2 && hotel && hotel.facilities &&
                        <HotelFacilitiesRender hotel={hotel} language={userlang} />
                    }
                    {
                        tabSelected === 3 && hotel && hotel.conditions &&
                        <TabContainer>
                            <Typography dangerouslySetInnerHTML={{
                                __html:
                                    (hotel.conditions || '').split('\r\n').join('<br />')
                            }}>
                            </Typography>
                        </TabContainer>
                    }
                </Collapse>
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(HotelHeaderRender));


// WEBPACK FOOTER //
// ./src/components/Reservation/HotelHeaderRender.js